import { useCallback, useEffect } from 'react';
import { useHistory } from 'src/shared/hooks/useHistory';
import { usePreviousPage } from 'src/util/history';
import { useScopedReducer } from './shefGlobalState';

/*
  set a back button state on component mount and remove the button when the
  component is unmounted
*/
export const useBackButton = (backPath: string) => {
  const { reduce: pathReduce } = useScopedReducer('backPath');
  const { reduce: visibleReduce } = useScopedReducer('backButtonVisible');

  useEffect(() => {
    pathReduce(() => backPath);
    visibleReduce(() => true);
    return () => visibleReduce(() => false);
  }, [backPath, pathReduce, visibleReduce]);
};

/*
  easy access to state of the back button in the header
  backPath: string location the back button will take you to
  backButtonVisible: if the user can see and click the back button
*/
export const useBackButtonState = () => {
  const { state: backPath } = useScopedReducer('backPath');
  const { state: backButtonVisible } = useScopedReducer('backButtonVisible');

  const { previousUrl } = usePreviousPage();
  const shouldBeBackAction = backPath === previousUrl;

  const history = useHistory();

  const goBack = useCallback(
    () => (shouldBeBackAction ? history.goBack() : history.push(backPath)),
    [backPath, history, shouldBeBackAction]
  );

  return { backPath, backButtonVisible, shouldBeBackAction, goBack, previousUrl };
};
